import login from './login';

export default {
  language: 'de-DE',
  country: 'de',
  name: 'Deutsch',
  embeddedLocale: login,
};
